<template>
	<div>
		<ts-page-title :title="$t('packageReturn.pageTitle')" :breadcrumb="[
			{ text: $t('home'), href: '/' },
			{
				text: $t('packageReturn.pageTitle'),
				active: true
			}
		]" />
			<ts-panel>
				<ts-panel-wrapper>
					<div class="tw-flex tw-justify-between">
						<div class="tw-flex tw-space-x-3">
							<div class="tw-flex tw-items-center tw-space-x-3">
								<a-button type="primary" @click="addNew" v-if="$can('create-package-returns')">
									{{ $t("addNew") }}
								</a-button>
								<a-range-picker
									v-model="dateRange"
									:allowClear="false"
									format="DD-MM-YYYY"
									valueFormat="DD-MM-YYYY"
									style="width: 200px"
									@change="fetchData()"
								/>
							</div>
						</div>
						<a-tooltip :title="$t('packageReturn.search')">
							<a-input-search
								v-model="search"
								:placeholder="$t('packageReturn.search')"
								style="width: 250px"
							/>
						</a-tooltip>
					</div>
				</ts-panel-wrapper>
				<div class="tw-overflow-x-scroll">
					<ts-table
						:columns="columns"
						:records="resources"
						:loading="loading"
					>
						<template v-slot="{ record }">
							<td class="tw-text-left">
								{{ record.status_changed_date }}
							</td>
							<td class="tw-text-left">
								{{ record.delivery_number }}
							</td>
							<td class="tw-text-left">
								{{ record.booking_number }}
							</td>
							<td class="tw-text-left">
								{{ record.shop_name }}
							</td>
							<td class="tw-text-left">
								{{ record.receiver_phone }}
							</td>
							<td class="tw-text-left">
								{{ record.return_driver_name || '-' }}
							</td>
							<td class="tw-text-left">
								{{ record.reason }}
							</td>
							<td class="tw-text-left">
								{{ record.created_by_name }}
							</td>
						</template>
					</ts-table>
				</div>
				<div class="d-flex justify-content-end tw-p-4">
					<ts-pagination
						v-model="pagination"
						@navigate="fetchData"
					></ts-pagination>
				</div>
			</ts-panel>
	</div>
</template>

<script>
import { debounce } from "lodash";
import { mapState } from "vuex";

export default {
	name: "packageReturnIndex",
	data() {
		return {
			loading: false,
		};
	},
	computed: {
		...mapState("agency/packageReturn", ["resources", "pagination"]),
		search: {
			get() {
				return this.$store.state.agency.packageReturn.search;
			},
			set(newValue) {
				this.$store.commit("agency/packageReturn/SET_SEARCH", newValue);
				this.$store.commit("agency/packageReturn/RESET_CURRENT_PAGE");
			}
		},
		dateRange: {
			get() {
				return this.$store.state.agency.packageReturn.dateRange;
			},
			set(newValue) {
				this.$store.commit(
					"agency/packageReturn/SET_DATE_RANGE",
					newValue
				);
			}
		},
		columns() {
			return [
				{
					name: this.$t("packageReturn.returnedDate"),
					style: "text-align:left",
					sortKey: 'status_changed_date'
				},
				{
					name: this.$t("packageReturn.deliveryNumber"),
					style: "text-align:center",
					sortKey: 'delivery_number'
				},
				{
					name: this.$t("packageReturn.bookingNumber"),
					style: "text-align:center",
					sortKey: 'booking_number'
				},
				{
					name: this.$t("packageReturn.shopName"),
					style: "text-align:left",
					sortKey: 'shop_name'
				},
				{
					name: this.$t("packageReturn.receiverPhone"),
					style: "text-align:center",
					sortKey: 'receiver_phone'
				},
				{
					name: this.$t("packageReturn.returnDriverName"),
					style: "text-align:left",
					sortKey: 'return_driver_name'
				},
				{
					name: this.$t("packageReturn.reason"),
					style: "text-align:left",
					sortKey: 'reason'
				},
				{
					name: this.$t("packageReturn.createdBy"),
					style: "text-align:left",
					sortKey: 'created_by_name'
				}
			];
		}
	},
	methods: {
		addNew() {
			this.$router.push({ name: 'package-return-create' })
		},
		fetchData(attributes) {
			this.loading = true;
			this.$store
				.dispatch("agency/packageReturn/fetch", { ...attributes })
				.then(() => {
					this.loading = false;
				})
				.catch(error => {
					this.loading = false;
					this.$notify({ type: "error", text: error.message });
				})
				.finally(() => {
					this.loading = false;
				});
		}
	},
	watch: {
		search: debounce(function() {
			this.fetchData();
		}, 500)
	},
	beforeRouteEnter(to, from, next) {
		next(vm => {
			vm.fetchData();
		});
	},
	beforeRouteLeave(to, from, next) {
		this.$store.commit("agency/packageReturn/RESET_STATE");
		next();
	}
}
</script>